export enum DeviceAssignmentType {
  Room = 'Room',
  Hc = 'Hc',
  Channel = 'Channel',
  Ventilation = 'Ventilation',
  RemoteHC = 'rmHc',
}

export interface CommissioningDeviceAssignHeatingCircuitParams {
  type: DeviceAssignmentType.Hc;
  deviceId: string;
  circuitId: string;
}

export interface CommissioningRemoteDeviceAssignHeatingCircuitParams {
  type: DeviceAssignmentType.RemoteHC;
  deviceId: string;
  circuitId: string;
}

export interface CommissioningRemoteDeviceAssignVentilationParams {
  type: DeviceAssignmentType.Ventilation;
  deviceId: string;
  ventilationId: string;
}
export interface CommissioningDeviceAssignRoomParams {
  type: DeviceAssignmentType.Room;
  deviceId: string;
  roomFeature: string;
  heatingCircuitId?: number;
  roomName: string;
}
export interface CommissioningDeviceAssignChannelParams {
  type: DeviceAssignmentType.Channel;
  fhtChannelDeviceId: string;
  roomFeature: string;
  roomName: string;
}

export type CommissioningDeviceAssignValidationParams = (
  | CommissioningDeviceAssignHeatingCircuitParams
  | CommissioningDeviceAssignRoomParams
  | CommissioningDeviceAssignChannelParams
  | CommissioningRemoteDeviceAssignHeatingCircuitParams
) & { isSuccess: boolean };
